export const API_URL = "https://cleantech-solution.onrender.com";